import { accountRequestStatusEnum } from '@/constants/user'

export function isRejectedAccountByApex(account) {
  return [
    accountRequestStatusEnum.SUSPENDED,
    accountRequestStatusEnum.ACTION_REQUIRED,
    accountRequestStatusEnum.REJECTED,
  ].includes(account.accountRequestStatus)
}
